// extracted by mini-css-extract-plugin
export default {"promotionsItemTag":"Tags_promotionsItemTag--wG2"};